import React from "react"
import { concatStrings } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbIcon from "../ui-kit/dfb_icon"

const CStatusHeadline = ({ headline, status, add_class }) => {
  const baseClass = "c-StatusHeadline"
  const icon =
    status === "success"
      ? "check-circle"
      : status === "error"
      ? "delete-circle"
      : null

  return (
    <div
      className={concatStrings(baseClass, `${baseClass}--${status}`, add_class)}
    >
      <DfbHeadline
        headline={headline}
        headline_level="h4"
        add_class={`${baseClass}-headline`}
      />
      {icon && <DfbIcon icon_type={icon} add_class={`${baseClass}-icon`} />}
    </div>
  )
}

export default CStatusHeadline
